var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M832 256c106.048 0 192 86.016 192 192v256a192 192 0 0 1-192 192H192a192 192 0 0 1-192-192V448c0-105.984 85.952-192 192-192h256V192.064c0-25.856 15.616-49.28 39.488-59.136a63.872 63.872 0 0 1 69.76 13.888l128 127.936c12.48 12.48 18.752 28.864 18.752 45.248s-6.272 32.768-18.752 45.248l-128 128a64.085333 64.085333 0 0 1-69.76 13.888A64.042667 64.042667 0 0 1 448 448v-64H192a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h640c35.392 0 64-28.608 64-64V448c0-35.392-28.608-64-64-64h-11.648c7.232-20.352 11.648-41.728 11.648-64s-4.416-43.648-11.648-64H832z",
    fill: "#2B96DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.8c46cf9f30183b2ff3aac962702c51eb.svg";
export { ForwardRef as ReactComponent };